var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeletedMessages(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1 0h18v18H-1z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.467)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#093D54",
    d: "M1.655 4.648h11.691v11.343a1.97 1.97 0 01-1.97 1.97H3.623a1.97 1.97 0 01-1.971-1.97V4.648h.002z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E5B7C",
    d: "M.02 3.342h15.043v1.306H.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ACE0F9",
    d: "M1.05 2.036h12.982v1.306H1.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E5B7C",
    d: "M10.349 2.036h-.67v-.744a.584.584 0 00-.584-.584H5.986a.584.584 0 00-.583.584v.744h-.67v-.744A1.255 1.255 0 015.986.039h3.11c.691 0 1.252.562 1.253 1.253v.744z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.186,
    height: 10.941,
    x: 3.801,
    y: 5.276,
    fill: "#0E5B7C",
    rx: 0.593
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.186,
    height: 10.941,
    x: 6.908,
    y: 5.276,
    fill: "#0E5B7C",
    rx: 0.593
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.186,
    height: 10.941,
    x: 10.015,
    y: 5.275,
    fill: "#0E5B7C",
    rx: 0.593
  })))));
}
export default SvgDeletedMessages;